import { BrowserProvider, Contract } from "ethers";
import copyAbi from "../contracts/copyAbi.json";
import artAbi from "../contracts/artAbi.json";
import { createContext } from "react";
import { useState } from "react";

const ART_CONTRACT_ADDR = '0x6Ad90127f097e89Ab957c49B2066FA727260D7b9';
const COPY_CONTRACT_ADDR = '0x1caA313c968D418bdE8FAE59eaf0F715345A5967';
const CHAIN_ID_DEC = 23295;
const chainParams = [{
    chainId: "0x5aff",
    rpcUrls: ["https://testnet.sapphire.oasis.io/"],
    chainName: "Oasis Sapphire Testnet",
    nativeCurrency: {
        name: "TEST",
        symbol: "TEST",
        decimals: 18
    },
    blockExplorerUrls: ["https://explorer.oasis.io/testnet/sapphire/"]
}]

export const WalletContext = createContext();

export const WalletContextProvider = ({children}) => {
    const [provider, setProvider] = useState(null);
    const [signer, setSigner] = useState(null);
    const [address, setAddress] = useState(null);
    const [artContract, setArtContract] = useState(null);
    const [copyContract, setCopyContract] = useState(null);

    const connectWallet = async () => {
        if (window.ethereum) {
            // await window.ethereum.request({method: "wallet_addEthereumChain", params: chainParams});
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const tempProvider = new BrowserProvider(window.ethereum);
            setProvider(tempProvider);
            const tempSigner = await tempProvider.getSigner();
            setSigner(tempSigner);
            const tempAddress = await tempSigner.getAddress();
            setAddress(tempAddress);
            const tempArtContract = new Contract(ART_CONTRACT_ADDR, artAbi.abi, tempSigner);
            setArtContract(tempArtContract);
            const tempCopyContract = new Contract(COPY_CONTRACT_ADDR, copyAbi.abi, tempSigner);
            setCopyContract(tempCopyContract);
        }
    };

    return (
        <WalletContext.Provider value={{connectWallet, provider, signer, address, artContract, copyContract}}>{children}</WalletContext.Provider>
    )
}